import { render, staticRenderFns } from "./SponsorProcess.vue?vue&type=template&id=afa1e4c2&scoped=true"
import script from "./SponsorProcess.vue?vue&type=script&lang=js"
export * from "./SponsorProcess.vue?vue&type=script&lang=js"
import style0 from "./SponsorProcess.vue?vue&type=style&index=0&id=afa1e4c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa1e4c2",
  null
  
)

export default component.exports